import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'uz',
  months: [
    'yanvar',
    'fevral',
    'mart',
    'aprel',
    'may',
    'iyun',
    'iyul',
    'avgust',
    'sentabr',
    'oktabr',
    'noyabr',
    'dekabr',
  ],
  monthsShort: ['yan', 'fev', 'mar', 'apr', 'may', 'iyn', 'iyl', 'avg', 'sen', 'okt', 'noy', 'dek'],
  weekdays: ['Yakshanba', 'Dushanba', 'Seshanba', 'Chorshanba', 'Payshanba', 'Juma', 'Shanba'],
  weekdaysMin: ['Y', 'D', 'S', 'C', 'P', 'J', 'S'],
  weekdaysShort: ['Yak', 'Dush', 'Sesh', 'Chor', 'Pay', 'Jum', 'Shan'],
  formats: {
    LT: 'H:mm',
    LTS: 'H:mm:ss',
    lt: 'H:mm',
    lts: 'H:mm:ss',
    L: 'DD/MM/YYYY',
    LL: 'D-MMMM, YYYY',
    'LL-D': 'MMMM, YYYY',
    'LL-Y': 'D-MMMM',
    LLL: 'D-MMMM, YYYY, H:mm',
    'LLL-Y': 'D-MMMM, HH:mm',
    LLLL: 'dddd, D-MMMM, YYYY, H:mm',
    'LLLL-Y': 'dddd D-MMMM, H:mm',
    l: 'DD/MM/YYYY',
    'l-Y': 'DD/MM',
    ll: 'D-MMM, YYYY',
    'll-Y': 'D-MMM',
    'll-D': 'MMM, YYYY',
    lll: 'D-MMM, YYYY, H:mm',
    'lll-Y': 'D-MMM, HH:mm',
    llll: 'ddd, D-MMM, YYYY, H:mm',
    'llll-Y': 'ddd, D-MMM, H:mm',
    'll-Y+w': 'ddd, D-MMM',
    'LT+to': 'H:mm ([GMT]Z)',
    'LLL+to': 'D-MMMM, YYYY, H:mm ([GMT]Z)',
  },
  meridiem: { am: 'TO', pm: 'TK', AM: 'TO', PM: 'TK' },
  past: {
    y: { one: '%s yil oldin', other: '%s yil oldin' },
    M: { one: '%s oy oldin', other: '%s oy oldin' },
    w: { one: '%s hafta oldin', other: '%s hafta oldin' },
    d: { one: '%s kun oldin', other: '%s kun oldin' },
    h: { one: '%s soat oldin', other: '%s soat oldin' },
    m: { one: '%s daqiqa oldin', other: '%s daqiqa oldin' },
    s: { one: '%s soniya oldin', other: '%s soniya oldin' },
  },
  future: {
    y: { one: '%s yildan keyin', other: '%s yildan keyin' },
    M: { one: '%s oydan keyin', other: '%s oydan keyin' },
    w: { one: '%s haftadan keyin', other: '%s haftadan keyin' },
    d: { one: '%s kundan keyin', other: '%s kundan keyin' },
    h: { one: '%s soatdan keyin', other: '%s soatdan keyin' },
    m: { one: '%s daqiqadan keyin', other: '%s daqiqadan keyin' },
    s: { one: '%s soniyadan keyin', other: '%s soniyadan keyin' },
  },
  pastLong: {
    y: { one: '%s yil oldin', other: '%s yil oldin' },
    M: { one: '%s oy oldin', other: '%s oy oldin' },
    w: { one: '%s hafta oldin', other: '%s hafta oldin' },
    d: { one: '%s kun oldin', other: '%s kun oldin' },
    h: { one: '%s soat oldin', other: '%s soat oldin' },
    m: { one: '%s daqiqa oldin', other: '%s daqiqa oldin' },
    s: { one: '%s soniya oldin', other: '%s soniya oldin' },
  },
  futureLong: {
    y: { one: '%s yildan keyin', other: '%s yildan keyin' },
    M: { one: '%s oydan keyin', other: '%s oydan keyin' },
    w: { one: '%s haftadan keyin', other: '%s haftadan keyin' },
    d: { one: '%s kundan keyin', other: '%s kundan keyin' },
    h: { one: '%s soatdan keyin', other: '%s soatdan keyin' },
    m: { one: '%s daqiqadan keyin', other: '%s daqiqadan keyin' },
    s: { one: '%s soniyadan keyin', other: '%s soniyadan keyin' },
  },
  abbr: {
    y: { one: '%s yil', other: '%s yil' },
    M: { one: '%s oy', other: '%s oy' },
    w: { one: '%s hafta', other: '%s hafta' },
    d: { one: '%s kun', other: '%s kun' },
    h: { one: '%s soat', other: '%s soat' },
    m: { one: '%s daq.', other: '%s daq.' },
    s: { one: '%s son.', other: '%s son.' },
  },
  full: {
    y: { one: '%s yil', other: '%s yil' },
    M: { one: '%s oy', other: '%s oy' },
    w: { one: '%s hafta', other: '%s hafta' },
    d: { one: '%s kun', other: '%s kun' },
    h: { one: '%s soat', other: '%s soat' },
    m: { one: '%s daqiqa', other: '%s daqiqa' },
    s: { one: '%s soniya', other: '%s soniya' },
  },
  justNow: 'Hozirgina',
  yesterday: 'Kecha',
  today: 'Bugun',
  tomorrow: 'Ertaga',
  weekStart: 1,
  timeRange: '%$1s – %$2s',
  timeZone: '%$1s %$2s',
  timePref: {},
  timeRangeStyles: {
    yl: { start: 'D-MMMM, YYYY', end: 'D-MMMM, YYYY' },
    'yl-1': { start: 'D-MMMM', end: 'D-MMMM, YYYY' },
    ml: { start: 'D-MMMM', end: 'D-MMMM' },
    'ml-1': { start: 'D', end: 'D-MMMM, YYYY' },
    dl: { start: 'D', end: 'D-MMMM' },
    y: { start: 'D-MMM, YYYY', end: 'D-MMM, YYYY' },
    'y-1': { start: 'D-MMM', end: 'D-MMM, YYYY' },
    m: { start: 'D-MMM', end: 'D-MMM' },
    'm-1': { start: 'D', end: 'D-MMM, YYYY' },
    d: { start: 'D', end: 'D-MMM' },
    Y: { start: 'ddd, D-MMM, YYYY', end: 'ddd, D-MMM, YYYY' },
    'Y-1': { start: 'ddd, D-MMM', end: 'ddd, D-MMM, YYYY' },
    M: { start: 'ddd, D-MMM', end: 'ddd, D-MMM' },
    D: { start: 'ddd, D-MMM', end: 'ddd, D-MMM' },
    yt: { start: 'D-MMM, YYYY, H:mm', end: 'D-MMM, YYYY, H:mm' },
    mt: { start: 'D-MMM, H:mm', end: 'D-MMM, H:mm' },
    dt: { start: 'D-MMM, H:mm', end: 'D-MMM, H:mm' },
    t: { start: 'HH:mm', end: 'HH:mm' },
    'yt+to': { start: 'D-MMM, YYYY, H:mm', end: 'D-MMM, YYYY, H:mm ([GMT]Z)' },
    'mt+to': { start: 'D-MMM, H:mm', end: 'D-MMM, H:mm ([GMT]Z)' },
    'dt+to': { start: 'D-MMM, H:mm', end: 'D-MMM, H:mm ([GMT]Z)' },
    't+to': { start: 'HH:mm', end: 'HH:mm ([GMT]Z)' },
  },
};
const localeName: LocaleName = 'uz';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  ordinal: (n) => `${n}`,
  meridiem: (hour, _, isLowerCase = false): string => {
    if (hour < 12) {
      return isLowerCase ? 'TO' : 'TO';
    } else {
      return isLowerCase ? 'TK' : 'TK';
    }
  },
};
